module.exports = __webpack_public_path__ + "img/678w.d3510f2.jpg";